module.exports = __webpack_public_path__ + "static/media/mode-2.825a6175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2.svg
// module id = 975
// module chunks = 2